import type { HttpCore } from '../http';
import type { TenantInfo } from '../types';

/** `/api/v1/tenant` — anonymous branding/plans/locales for the current host or X-Tenant header. */
export function createTenantApi(http: HttpCore) {
  return {
    get: () => http.get<TenantInfo>('/tenant', { auth: false }),
  };
}

export type TenantApi = ReturnType<typeof createTenantApi>;
